// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"35":"0d8b4a26","70":"32fef241","249":"c7bcb34a","284":"8f963dbc","388":"e717c532","453":"1714ce7c","521":"9f197ec8","704":"b67ae1d3","705":"d881891d","761":"4ddfbe99","912":"8c4d4684","921":"a81de450","961":"38c4846c","975":"eb93ee6c"}[chunkId] + ".chunk.js";
};